import classNames from 'classnames';
import { Link } from 'react-router-dom';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';

export default function ViewMoreDetails({
  label = '',
  isSmallScreen = false,
  icon = null,
  className = '',
  iconClassName = '',
  url = '',
}) {
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <div
      className={classNames(`${className} flex items-start`, {
        'flex-row-reverse': !isSmallScreen,
      })}
    >
      <Link
        style={{ backgroundColor: secondaryColour }}
        to={url}
        className="relative p-[15px] text-white fill-white rounded-full"
      >
        <div className="absolute w-full inset-0 flex items-center justify-center">
          <div className={iconClassName}>{icon}</div>
        </div>
      </Link>
      <div
        className={classNames('font-bold', {
          'mr-2': !isSmallScreen,
          'ml-2': isSmallScreen,
        })}
      >
        <Link className="text-[18px]" to={url}>
          {label}
        </Link>
      </div>
    </div>
  );
}
